// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-enter-active,.page-leave-active{transition-property:opacity,transform}.page-enter-active{transition-duration:.3s;transition-timing-function:ease}.page-leave-active{transition-duration:.15s;transition-timing-function:cubic-bezier(1,.5,.8,1)}.page-enter,.page-leave-to{opacity:0}.page-enter{transform:translateX(1rem)}.page-leave-to{transform:translateX(-1rem)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
